import { ButtonTheme, ButtonType } from '@ui-components/PlayButton';
import { SIZE } from '@ui-components/typography/PlayText';
import { UserSurveyFragment } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import { Task as TaskModel } from '../models';
import { Button, Byline, Heading, TaskButtonWrapper } from '../UsabilityTest.styles';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    task: TaskModel;
    onCloseSurvey: (value: string) => void;
    survey: UserSurveyFragment;
};

const Task = ({ onClick, task, onCloseSurvey, survey }: Props) => (
    <>
        <Byline size={SIZE.SMALL}>Uppgift</Byline>

        <Heading>{task.heading}</Heading>

        <TaskButtonWrapper>
            <Button
                buttonType={ButtonType.BUTTON}
                theme={ButtonTheme.DEFAULT}
                type="button"
                onClick={() => {
                    onCloseSurvey(survey.id);
                }}
                cancel
            >
                Avbryt
            </Button>
            <Button buttonType={ButtonType.BUTTON} onClick={onClick} theme={ButtonTheme.WHITE}>
                Jag är klar med uppgiften
            </Button>
        </TaskButtonWrapper>
    </>
);

export default Task;
